module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('audio', {
    ref: "soundbeep",
    attrs: {
      "src": "assets/beep.wav",
      "autostart": "false"
    }
  }), _vm._v(" "), _c('audio', {
    ref: "sounderror",
    attrs: {
      "src": "assets/error.wav",
      "autostart": "false"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row well well-sm",
    staticStyle: {
      "border-bottom": "1px solid gray"
    }
  }, [_c('div', {
    staticClass: "col-md-6 col-sm-6 "
  }, [(_vm.Bag.patientId) ? _c('div', [_c('a', {
    staticClass: "btn btn-link",
    staticStyle: {
      "padding": "0px"
    },
    on: {
      "click": _vm.navigateToPatient
    }
  }, [_c('h3', {
    staticClass: "text-info",
    staticStyle: {
      "margin-top": "-5px",
      "margin-bottom": "2px"
    }
  }, [_vm._v(_vm._s(_vm.Bag.firstName) + " " + _vm._s(_vm.Bag.middleName) + " " + _vm._s(_vm.Bag.lastName))])]), _vm._v(" "), _c('table', [_c('tr', [_vm._m(0), _c('td', [_vm._v(_vm._s(_vm.FormatDate(_vm.Bag.dob)))])]), _vm._v(" "), _c('tr', [_vm._m(1), _c('td', [_vm._v(_vm._s(_vm.Bag.nhsNumber))])]), _vm._v(" "), _c('tr', [_vm._m(2), _vm._v(" "), _c('td', [_c('small', [_c('span', [_vm._v(_vm._s(_vm.Bag.addressLine) + "       ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.Bag.postCode) + "      ")])])])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-md-offset-2 col-sm-6 "
  }, [_c('div', {
    staticClass: "col-md-8 col-sm-8 pull-right"
  }, [(_vm.addingAggCode) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.enteredAggCode),
      expression: "enteredAggCode"
    }],
    ref: "aggCodeInput",
    staticClass: "form-control pull-right",
    staticStyle: {
      "height": "36px",
      "width": "100%"
    },
    attrs: {
      "placeholder": "Scan / Enter Aggregated Code"
    },
    domProps: {
      "value": (_vm.enteredAggCode)
    },
    on: {
      "keydown": _vm.AggCodeKeyDown,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.enteredAggCode = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.addingAggCode && !this.Bag.aggregatedCode) ? _c('a', {
    staticClass: "btn btn-sm btn-default",
    staticStyle: {
      "width": "100%"
    },
    on: {
      "click": _vm.startAggCode
    }
  }, [_vm._v(" Add Aggregated Code")]) : _vm._e(), _vm._v(" "), (this.Bag.aggregatedCode) ? _c('a', {
    staticClass: "btn btn-sm btn-default",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._v(_vm._s(this.Bag.aggregatedCode))]) : _vm._e()]), _vm._v(" "), (_vm.Bag.patientId) ? _c('div', {
    staticStyle: {
      "height": "100%",
      "display": "inline-block",
      "vertical-align": "bottom",
      "float": "none"
    }
  }, [_c('a', {
    staticClass: "btn btn-sm btn-default",
    staticStyle: {
      "margin-right": "10px"
    },
    on: {
      "click": _vm.EditPatient
    }
  }, [_vm._v("Edit Patient")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [(_vm.Bag.isRemoved) ? _c('div', {
    staticStyle: {
      "margin": "10px"
    }
  }, [_vm._m(3)]) : _vm._e(), _vm._v(" "), (!_vm.Bag.isRemoved) ? _c('div', {
    staticStyle: {
      "margin": "10px"
    }
  }, [(this.Items.length == 0) ? _c('a', {
    staticClass: "btn btn-sm btn-danger",
    staticStyle: {
      "margin-right": "10px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.DeleteBag($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "5px"
    }
  }, [_vm._v("Delete")])]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "btn btn-sm btn-default",
    class: {
      'btn-success': _vm.Bag.status == 'Working'
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.SetBagStatus(10)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "5px"
    }
  }, [_vm._v("Working")])]), _vm._v(" "), (_vm.Items.length > 0 && _vm.Bag.bagStatus == 10) ? _c('span', [_c('i', {
    staticClass: "fa fa-chevron-right"
  }), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary btn-sm",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.SetBagStatus(20)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-bag"
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "5px"
    }
  }, [_vm._v("Ready for Delivery")])])]) : _vm._e(), _vm._v(" "), (_vm.Items.length > 0 && _vm.Bag.bagStatus == 20) ? _c('span', [_c('i', {
    staticClass: "fa fa-chevron-right"
  }), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('i', {
    staticClass: "fa fa-chevron-right"
  }), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary btn-sm",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.SetBagStatus(30)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-paper-plane"
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "5px"
    }
  }, [_vm._v("Mark Delivered")])])]) : _vm._e(), _vm._v(" "), (_vm.Items.length > 0 && _vm.Bag.bagStatus == 30) ? _c('span', [_c('i', {
    staticClass: "fa fa-chevron-right"
  }), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('i', {
    staticClass: "fa fa-chevron-right"
  }), _vm._v(" "), _c('a', {
    staticClass: "btn btn-success btn-sm",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.SetBagStatus(30)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-paper-plane"
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "5px"
    }
  }, [_vm._v("Delivered")])])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [(_vm.ScannerStatus == 0) ? _c('a', {
    staticClass: "btn btn-sm btn-primary pull-right",
    staticStyle: {
      "margin": "5px"
    },
    on: {
      "click": _vm.RefreshItems
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v("\n                Reload\n            ")]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "btn btn-sm btn-info pull-right",
    staticStyle: {
      "margin": "5px"
    },
    on: {
      "click": _vm.CalibrateScanner
    }
  }, [_c('i', {
    staticClass: "fa fa-cog fa-1x"
  }), _vm._v("  Configure")]), _vm._v(" "), (_vm.ScannerStatus == 0 && _vm.DocumentHasFocus) ? _c('a', {
    staticClass: "btn btn-sm btn-info pull-right",
    staticStyle: {
      "margin": "5px"
    }
  }, [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  }), _vm._v("\n                Reader Active\n            ")]) : _vm._e(), _vm._v(" "), (_vm.ScannerStatus == 0 && !_vm.DocumentHasFocus) ? _c('a', {
    staticClass: "btn btn-sm btn-warning pull-right",
    staticStyle: {
      "margin": "5px"
    }
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  }), _vm._v("\n                Reader Inactive\n            ")]) : _vm._e(), _vm._v(" "), (_vm.ScannerStatus == 1) ? _c('a', {
    staticClass: "btn btn-sm btn-danger pull-right",
    staticStyle: {
      "margin": "5px"
    }
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle faa-pulse"
  }), _vm._v("\n                Duplicate Item\n            ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row "
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "panel-body",
    staticStyle: {
      "min-height": "400px"
    }
  }, [(!_vm.Bag.isRemoved) ? _c('table', {
    staticClass: "table table-striped table-hover"
  }, [_vm._m(7), _vm._v(" "), _c('tbody', [_vm._l((_vm.Items), function(item, index) {
    return [_c('tr', [_c('td', [(item.isRemoved) ? _c('span', {
      staticClass: "text-danger"
    }, [_c('i', {
      staticClass: "fa fa-trash"
    }), _vm._v(" Removed")]) : _c('span', [_vm._v(_vm._s(_vm.FormatTime(item.whenCreated)))])]), _vm._v(" "), _c('td', [_c('TooltipControl', {
      attrs: {
        "title": _vm.ItemStatusMessage(item)
      }
    }, [(item.status == 10 ||
      item.status == 50 ||
      item.status == 80 ||
      item.status == 110 ||
      item.status == 140) ? _c('i', {
      staticClass: "fa fa-refresh fa-spin"
    }) : _vm._e(), _vm._v("\n\n\n\n                                            " + _vm._s(_vm.GetFmdStatusDescription(item.status)) + "\n                                        ")])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.gtin))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.sn))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.drugName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.batchNumber))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.FormatFmdDate(item.expiryDate)))]), _vm._v(" "), _c('td', [(!item.isRemoved && item.status != 60) ? _c('a', {
      staticClass: "text-warning",
      attrs: {
        "href": "#",
        "data-toggle": "tooltip",
        "data-placement": "top",
        "title": "Remove Item"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.DeleteItem(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash fa-1x"
    })]) : _vm._e(), _vm._v(" "), (!item.isRemoved && (item.status == 60 || item.status == 100)) ? _c('a', {
      staticClass: "text-primary",
      attrs: {
        "href": "#",
        "data-toggle": "tooltip",
        "data-placement": "top",
        "title": "Undo decommision"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.UndoDecommision(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-undo fa-1x"
    })]) : _vm._e()])])]
  }), _vm._v(" "), (_vm.EntryController) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "10"
    }
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('forminput', {
    attrs: {
      "controller": _vm.EntryController.gtin
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('forminput', {
    attrs: {
      "controller": _vm.EntryController.sn
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('forminput', {
    attrs: {
      "controller": _vm.EntryController.batch
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('forminput', {
    attrs: {
      "controller": _vm.EntryController.expiry
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), (_vm.EntryController) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "10"
    }
  }, [(!_vm.EntryController.hasError) ? _c('a', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "width": "100px"
    },
    on: {
      "click": _vm.AddManualEntry
    }
  }, [_vm._v("Add")]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "btn btn-warning",
    staticStyle: {
      "width": "100px"
    },
    on: {
      "click": _vm.StopManualEntry
    }
  }, [_vm._v("Cancel")])])]) : _vm._e(), _vm._v(" "), (!_vm.EntryController) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "100"
    }
  }, [_c('a', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.StartManualEntry
    }
  }, [_vm._v("Add Manually")])])]) : _vm._e()], 2)]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    ref: "myModal",
    staticClass: "modal fade",
    attrs: {
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-sm"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._v("\n                    Scan the aggregated barcode for this bag.\n                    "), _c('br'), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.enteredAggCode),
      expression: "enteredAggCode"
    }],
    staticClass: "form-control pull-right",
    staticStyle: {
      "height": "36px",
      "width": "100%"
    },
    attrs: {
      "id": "aggCodeDialogInput",
      "placeholder": "Scan / Enter Aggregated Code"
    },
    domProps: {
      "value": (_vm.enteredAggCode)
    },
    on: {
      "keydown": _vm.AggCodeKeyDown,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.enteredAggCode = $event.target.value
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default btn-sm",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Close")]), _vm._v(" "), (_vm.Bag.patientId) ? _c('button', {
    staticClass: "btn btn-warning btn-sm",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.disableAggregatedCode
    }
  }, [_vm._v("Dont Show Again")]) : _vm._e()])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('small', [_c('strong', [_vm._v("Dob :")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('small', [_c('strong', [_vm._v("Nhs Id :")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('small', [_c('strong', [_vm._v("Address :")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "btn btn-sm btn-danger",
    staticStyle: {
      "margin-right": "10px"
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "5px"
    }
  }, [_vm._v("Bag Removed")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "btn btn-success btn-sm"
  }, [_c('i', {
    staticClass: "fa fa-shopping-bag"
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "5px"
    }
  }, [_vm._v("Completed ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "btn btn-default btn-sm",
    attrs: {
      "href": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-bag"
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "5px"
    }
  }, [_vm._v("Completed ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "panel-title"
  }, [_vm._v("Bag Items")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Added Time")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("GTIN")]), _vm._v(" "), _c('th', [_vm._v("Serial")]), _vm._v(" "), _c('th', [_vm._v("DrugName")]), _vm._v(" "), _c('th', [_vm._v("Batch")]), _vm._v(" "), _c('th', [_vm._v("Expiry")]), _vm._v(" "), _c('th')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Aggregated Code")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-cafa3e7a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cafa3e7a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/components/FmdControls/BagManagement/BagManagementCore.scp.html
// module id = 509
// module chunks = 0